import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAllEmployeeList, getEmployeeList } from '../../services/viewTimeSheet';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import TimeSheetList from './timeSheetList';
import { appInsights } from '../../AppInsights';

const EmployeeTimeSheet = () => {
    const { userData } = useSelector(state => state.user);
    const hasPrivilegedRole = userData?.userTypes?.some(type => [1, 2, 3].includes(type?.userTypeRoleId));
    const managerId = userData?.userId; 
    const [employees, setEmployees] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedEmployee, setSelectedEmployee] = useState('all');
    const [selectedMonth, setSelectedMonth] = useState(new Date()?.getMonth());
    const [selectedProjectType, setSelectedProjectType] = useState(null);
    const currentUserTypeId = localStorage.getItem("userTypeId");
    const [employeeFilter, setEmployeeFilter] = useState("");
    const [selectedPeriodType, setSelectedPeriodType] = useState("all");
    const periodTypes = [
        { label: "All Period Types", value: "all" },
        { label: "Bi-Weekly", value: 2 },
        { label: "Monthly", value: 3 },
        { label: "Weekly", value: 1 },
    
      ];
    const projectTypes = [
        { label: 'All Project Types', value: 'all' },
        { label: 'External Projects', value: '2' },
        { label: 'Internal Projects', value: '1' }
    ];
    let year = [
        { label: 'All Years', value: null },
        { label: '2024', value: 2024 },
        { label: '2025', value: 2025 },
    ];
    const currentYear = new Date().getFullYear();
    if (!year.some(y => y.value === currentYear)) {
        year.push({ label: currentYear.toString(), value: currentYear });
    }

    const months = [
        { label: 'All Months', value: 'all' },
        { label: `January`, value: 1 }, { label: `February`, value: 2 }, { label: `March`, value: 3 },
        { label: `April`, value: 4 }, { label: `May`, value: 5 }, { label: `June`, value: 6 },
        { label: `July`, value: 7 }, { label: `August`, value: 8}, { label: `September`, value: 9 },
        { label: `October`, value: 10 }, { label: `November`, value: 11 }, { label: `December`, value: 12 }
    ];

    useEffect(() => {
        if (managerId) {
            fetchEmployees();
        }
    }, [managerId, hasPrivilegedRole]);


    const fetchEmployees = async () => {
        try {
            let response = hasPrivilegedRole ? await getAllEmployeeList() : await getEmployeeList(managerId);
            setEmployees([
                { label: 'All Employees', value: 'all' }, 
                ...response.map(emp => ({ 
                    label: emp?.userName?.split(' ')
                        ?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
                        ?.join(' '), 
                    value: emp?.userId 
                }))
            ]);
        } catch (error) {
            appInsights.trackException("Get employeeTimeSheet", { exception: error });
            console.error('Error fetching employees:', error);
        }
    };
    return (
        <div className='employee_container p-3 mx-2 my-2'>
            <div className="p-grid p-mb-3 grid pt-4 pl-2 mt-2">
                        <div className="col-12 md:col-3">
                          <Dropdown
                            value={selectedPeriodType}
                            options={periodTypes}
                            onChange={(e) => setSelectedPeriodType(e?.value)}
                            placeholder="Period Type"
                            className="w-full"
                          />
                        </div>
                 <div className='col-12 md:col-3'>   
                    <Dropdown
                        value={selectedYear}
                        options={year}
                        onChange={(e) => setSelectedYear(e?.value)}
                        placeholder="Select Year"
                        className="w-full"
                    />
               
                </div>
                <div className='col-12 md:col-3'>
                    <Dropdown
                        value={selectedMonth}
                        options={months}
                        onChange={(e) => setSelectedMonth(e?.value)}
                        placeholder="Select Month"
                        className="w-full"
                    />
                </div>
                <div className='col-12 md:col-3'>
                    <Dropdown
                        value={selectedProjectType}
                        options={projectTypes}
                        onChange={(e) => setSelectedProjectType(e?.value)}
                        placeholder="Select Project Type"
                        className="w-full"
                    />
                </div>
                <div className='col-12 md:col-3'>
                    <Dropdown
                        value={selectedEmployee}
                        options={employees}
                        onChange={(e) => setSelectedEmployee(e?.value)}
                        placeholder="Select an Employee"
                        className="w-full"
                        filter
                        filterValue={employeeFilter}
                        onFilter={(e) => setEmployeeFilter(e.filter)}
                        showClear
                    />
                </div> 
            </div>
            {selectedEmployee && (
                <TimeSheetList 
                    employeeId={selectedEmployee} 
                    selectedMonth={selectedMonth} 
                    projectType={selectedProjectType} 
                    year={selectedYear}
                    periodTypeId={selectedPeriodType}
                />
            )}
        </div>
    );
};

export default EmployeeTimeSheet;
